export const enum OAuthScope {
    orders_read = 'orders_read',
    orders_write = 'orders_write',
}

export const enum OAuthAppStatus {
    ACTIVE = 'ACTIVE',
    DISABLED = 'DISABLED',
}

export type OAuthApp = {
    _id: string;
    name: string;
    vendorName: string;
    clientId: string;
    confidential: boolean;
    redirectUris: string[];
    allowedScopes: OAuthScope[];
    allowedOrganizations: string[];
    /** DD-3670: trusted app, may use the client_credentials grant. */
    allowClientCredentials: boolean;
    status: OAuthAppStatus;
    createdBy: string;
    createdAt: string;
    updatedAt: string;
};

export type OAuthAppWithSecret = {
    app: OAuthApp;
    clientSecret: string | null;
};

export type CreateOAuthAppInput = {
    name: string;
    vendorName: string;
    redirectUris: string[];
    allowedScopes: OAuthScope[];
    allowedOrganizations: string[];
    confidential: boolean;
    allowClientCredentials: boolean;
};

export type UpdateOAuthAppInput = {
    name: string;
    vendorName: string;
    redirectUris: string[];
    allowedScopes: OAuthScope[];
    allowedOrganizations: string[];
    allowClientCredentials: boolean;
};
